<template>
  <div class="article-page">
    <Spinner v-if="article.status.value === 'pending'" />
    <div v-else-if="article.status.value === 'error'">
      {{ article.error.value }}
    </div>
    <article v-else-if="article.data.value?.id">
      <NuxtLink
        class="edit-link"
        v-if="isContentEditor().value"
        :to="`/articles/edit?id=${article.data.value?.id}`"
        >Edit</NuxtLink
      >
      <Editor :model-value="article.data?.value?.content" />
    </article>
    <article v-else>
      <h1>Article not found</h1>
      <p>
        Maybe you'll find what you're looking for in
        <nuxt-link to="/articles">our list of articles.</nuxt-link>
      </p>
    </article>
  </div>
</template>
<script lang="ts" setup>
definePageMeta({
  layout: "marketing",
  authenticated: false,
});

const router = useRouter();
const slug = useParam("slug");

const article = useSupabaseQuery({
  queryKey: () => ["articles", { slug: slug.value }],
  queryFn: (S) =>
    S.rpc("get_post_by_slug_or_id", { slug_or_id: slug.value! })
      .select("*,slugs(*)")
      .maybeSingle(),
});

function handleDefaultSlug() {
  const defaultSlug = article.data.value?.slugs.find((s) => s.default);
  if (defaultSlug && slug.value !== defaultSlug.slug) {
    router.replace(`/articles/${defaultSlug.slug}`);
  }
}

watch(article.data, handleDefaultSlug, { immediate: true });

onServerPrefetch(async () => {
  const res = await article.suspense();

  const ourSlug = res.data?.slugs.find((s) => s.slug === slug.value);
  if (ourSlug?.default === false) {
    const defaultSlug = res.data?.slugs.find((s) => s.default);
    if (defaultSlug) {
      router.replace(`/articles/${defaultSlug.slug}`);
    }
  }
});
</script>
<style scoped>
.article-page {
  display: grid;
  place-content: center;
  min-height: 20vh;
}

.edit-link {
  display: block;
  width: 100%;
  text-align: right;
}
</style>
